// extracted by mini-css-extract-plugin
module.exports = {"loading":"MainPageLoader_loading_2E2dA"};